import { useCallback, useEffect, useMemo } from 'react';
import { useFormAdapter, useFormFields } from '@eti/providers';
export const useMuxCrossStepHide = ({
  muxProductIds,
  getFormSection
}) => {
  const {
    setValue
  } = useFormAdapter();
  const muxProductsFormSections = useMemo(() => muxProductIds.map(id => {
    var _getFormSection;
    return (_getFormSection = getFormSection(id)) !== null && _getFormSection !== void 0 ? _getFormSection : '';
  }), [muxProductIds, getFormSection]);
  const {
    value: muxMemberSelections
  } = useFormFields(muxProductsFormSections.map(formSection => `${formSection}.value.value`));

  // `useFormFields` returns a fresh array on every render, so derive a stable signature
  // from the actual selection values. Without this, `muxMemberSelected` (and the effect
  // below) would change identity every render and re-run setValue in a loop.
  const selectionSignature = muxProductsFormSections.map((_section, index) => (muxMemberSelections === null || muxMemberSelections === void 0 ? void 0 : muxMemberSelections[index]) === true || (muxMemberSelections === null || muxMemberSelections === void 0 ? void 0 : muxMemberSelections[index]) === 'true' ? '1' : '0').join('');
  const muxMemberSelected = useMemo(() => [...selectionSignature].map(flag => flag === '1'), [selectionSignature]);
  const isMutuallyExclusiveMemberHidden = useCallback(productId => {
    const memberIndex = muxProductIds.indexOf(Number(productId));
    if (memberIndex === -1) {
      return false;
    }

    // Hide this product when the other product of the MUX is selected.
    return Boolean(muxMemberSelected[memberIndex === 0 ? 1 : 0]);
  }, [muxProductIds, muxMemberSelected]);

  // Safety net: if a member is hidden but still carries a selection (e.g. from persisted
  // state), clear it so a mutually-exclusive products can never be submitted together.
  useEffect(() => {
    muxProductsFormSections.forEach((_section, index) => {
      const isHidden = muxMemberSelected[index === 0 ? 1 : 0];
      if (isHidden && muxMemberSelected[index] && muxProductsFormSections[index]) {
        setValue(muxProductsFormSections[index], {
          value: {
            value: false,
            priceRaw: 0
          }
        });
      }
    });
  }, [muxProductsFormSections, muxMemberSelected, setValue]);
  return {
    isMutuallyExclusiveMemberHidden
  };
};
//# sourceMappingURL=useMuxCrossStepHide.js.map